import { Link } from 'react-router-dom';

interface RelatedResource {
  title: string;
  description: string;
  path: string;
  icon: string;
}

interface RelatedResourcesProps {
  resources: RelatedResource[];
}

export default function RelatedResources({ resources }: RelatedResourcesProps) {
  return (
    <section className="bg-gradient-to-br from-gray-50 to-white py-16 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">Related Resources</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Continue exploring helpful resources to grow your El Paso business
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {resources.map((resource, index) => (
            <Link
              key={index}
              to={resource.path}
              className="group bg-white rounded-xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 border border-gray-100 hover:border-[#D2691E]/30 cursor-pointer"
              aria-label={`Learn more about ${resource.title}`}
            >
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-br from-[#D2691E] to-[#B8571A] rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className={`${resource.icon} text-white text-xl`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-900 mb-2 group-hover:text-[#D2691E] transition-colors">
                    {resource.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {resource.description}
                  </p>
                  <div className="mt-3 flex items-center text-[#D2691E] text-sm font-medium">
                    <span>Explore resource</span>
                    <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}